import axios from "axios";

const TodayAttendanceService = {
  getAttendance: (date, company, location) =>
    axios.get(
      `attme/GetAttendance?date=${date}&company=${company}&location=${location}`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),
};

export default TodayAttendanceService;
